var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("Message.SelectCopyContent"),
            width: "760px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "sea-booking-copy-window" },
            [
              _c(
                "div",
                { staticClass: "scheme-toolbar" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.openSaveSchemeDialog }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SaveAsScheme")))]
                  ),
                  _c("span", { staticClass: "scheme-current" }, [
                    _vm._v("当前方案：" + _vm._s(_vm.currentSchemeName))
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary", plain: "" },
                      on: {
                        click: function($event) {
                          _vm.schemeSelectorVisible = true
                        }
                      }
                    },
                    [_vm._v("复制方案选择")]
                  )
                ],
                1
              ),
              _c("fieldset", { staticClass: "copy-fieldset" }, [
                _c("legend", [_vm._v(_vm._s(_vm.$t("Message.CopyContent")))]),
                _c(
                  "div",
                  { staticClass: "basic-grid" },
                  _vm._l(_vm.basicItems, function(item) {
                    return _c(
                      "el-checkbox",
                      {
                        key: item.itemKey,
                        attrs: {
                          value: _vm.isItemSelected(item.itemKey),
                          disabled: item.itemKey === "basicInfo"
                        },
                        on: {
                          change: function($event) {
                            return _vm.onItemSelectionChange(
                              item.itemKey,
                              $event
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.renderItemLabel(item)))]
                    )
                  }),
                  1
                ),
                _c("div", { staticClass: "copy-divider" }),
                _c(
                  "div",
                  { staticClass: "detail-grid" },
                  _vm._l(_vm.detailItems, function(item) {
                    return _c(
                      "el-checkbox",
                      {
                        key: item.itemKey,
                        attrs: { value: _vm.isItemSelected(item.itemKey) },
                        on: {
                          change: function($event) {
                            return _vm.onItemSelectionChange(
                              item.itemKey,
                              $event
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.renderItemLabel(item)))]
                    )
                  }),
                  1
                )
              ]),
              _c(
                "el-checkbox",
                {
                  staticClass: "copy-tip",
                  model: {
                    value: _vm.options.notMatchAgainSelect,
                    callback: function($$v) {
                      _vm.$set(_vm.options, "notMatchAgainSelect", $$v)
                    },
                    expression: "options.notMatchAgainSelect"
                  }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("queryJob.WhenDepartmentBranchNewSelection")
                      )
                    )
                  ])
                ]
              ),
              _c(
                "div",
                { staticClass: "copy-number-row" },
                [
                  _c("label", [_vm._v(_vm._s(_vm.$t("Message.CopyNumber")))]),
                  _c("el-input-number", {
                    attrs: {
                      value: _vm.options.copyNum,
                      precision: 0,
                      min: 1,
                      max: 100,
                      "controls-position": "right"
                    },
                    on: { input: _vm.onCopyNumInput }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirm }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.schemeSelectorVisible,
            title: "复制方案选择",
            width: "420px",
            "append-to-body": "",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.schemeSelectorVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "scheme-selector-list" },
            _vm._l(_vm.schemeList, function(scheme) {
              return _c(
                "div",
                {
                  key: _vm.schemeKey(scheme),
                  staticClass: "scheme-selector-item"
                },
                [
                  _c("span", { staticClass: "scheme-selector-name" }, [
                    _vm._v(" " + _vm._s(scheme.configName) + " "),
                    _vm.isSchemeDefault(scheme)
                      ? _c("span", { staticClass: "scheme-default-tag" }, [
                          _vm._v("默认")
                        ])
                      : _vm._e()
                  ]),
                  _c(
                    "div",
                    { staticClass: "scheme-selector-actions" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini" },
                          on: {
                            click: function($event) {
                              return _vm.selectScheme(scheme)
                            }
                          }
                        },
                        [_vm._v("使用")]
                      ),
                      !scheme.builtin && !_vm.isSchemeDefault(scheme)
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                type: "primary",
                                plain: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.setSchemeAsDefault(scheme)
                                }
                              }
                            },
                            [_vm._v("设为默认")]
                          )
                        : _vm._e(),
                      !scheme.builtin
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                type: "danger",
                                plain: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.deleteScheme(scheme)
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            }),
            0
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.schemeSelectorVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.saveSchemeDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_SaveAsScheme"),
            width: "360px",
            "append-to-body": "",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.saveSchemeDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "top" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "方案名称" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "50" },
                    model: {
                      value: _vm.saveSchemeDialog.name,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.saveSchemeDialog,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "saveSchemeDialog.name"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveAsScheme } },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.saveSchemeDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }